import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../global.service';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { AngularFireAnalytics } from '@angular/fire/analytics';
@Component({
  selector: 'app-frequent-questions',
  templateUrl: './frequent-questions.component.html',
  styleUrls: ['./frequent-questions.component.sass']
})
export class FrequentQuestionsComponent implements OnInit {
  public expand=[];
  public tabActive='Soporte';
  public currentList;
  public postpago=false;
  public prepago=false;
  public telefoniaFijo=false;
  public totalAccountList;
  public token:string=sessionStorage.getItem("token");
  public selectBan;
  public type;

  public content:object;
  constructor(public AngularFireAnalytics:AngularFireAnalytics, public global:GlobalService, private loadingScreenService: LoadingScreenService) {
    this.AngularFireAnalytics.setCurrentScreen("Preguntas Frecuentes");
    this.AngularFireAnalytics.logEvent("Preguntas Frecuentes-Screenview");
  }

  ngOnInit() {
    this.global.validateSession();
    // if(this.global.sessionReview()==true){
    //   this.expand[0]=true;
    // }
    this.content={
      content:[
        {
          title:"¿Como me registro?",
          description:"Para registrar tu cuenta en Mi Claro Solo necesitas Número de teléfono de Claro PR, PIN que llegara vía mensaje de texto a tu numero celular o vía correo electrónico. los últimos 4 del seguro social del titular de la cuenta, correo electrónico y contraseña a utilizar.",
          expand:true
        },
        {
          title:"Cuando me registro, el sistema no me pregunto nombre de usuario.",
          description:"El nombre de usuario es tu número de teléfono móvil o correo electrónico utilizado para registrarse.",
          expand:false
        },
        {
          title:"¿Cómo añadir una cuenta adicional en mi usuario ya existente de Mi Claro?",
          description:"Puedes añadir una cuenta adicional bajo el mismo usuario existente a través de la misma aplicación. Dentro de Mi Claro oprime Mis Cuentas, en la parte superior de tu pantalla oprime Agregar Cuentas. El sistema te solicitara número de cuenta a incluir y últimos 4 del seguro social del titular de la cuenta. Para finalizar oprime, guardar cuenta. Para ver el cambio en efecto, debes de salir y volver a entrar a la aplicación.",
          expand:false
        },
        {
          title:"¿Cómo desbloquear mi cuenta?",
          description:"Si bloqueas tu usuario de Mi Claro, podrás recuperar el acceso de una manera simple. Luego de 3 intentos fallidos para entrar a Mi Claro, se levantará un mensaje donde te indicará lo siguiente: Hemos detectado una actividad inusual en el uso de tus credenciales de acceso. Espera unos segundos que un representante de servicio estará habilitando una sesión de Chat para darte soporte con tu problema de acceso. De solicitar asistencia adicional, puedes escribirnos a miclaro@claropr.com.",
          expand:false
        },
        {
          title:"¿Tiene problemas de conexión al acceder a Mi Claro?",
          description:"Si tienes problemas de conexión, verifica que tengas actualizada la aplicación con la última versión. Asegúrate que tu conexión de data es una estable y se encuentre activa o que tenga conexión Wi-Fi disponible o Intenta acceder a través de los navegadores CHROME o FIRE FOX. También puedes revisar las opciones de tu navegador y eliminar los cookies o archivos temporeros.",
          expand:false
        },
        {
          title:"¿No he recibido mi factura?",
          description:"Si es un nuevo cliente su factura debe estar en formato digital. Para ver su factura, información sobre su cuenta y hacer pagos, regístrate en Mi Claro PR. Tienes opciones de App y Web disponibles. Dentro de Mi Claro PR en el módulo de Factura y Pago tendrás acceso al Historial de Facturas y las mismas se pueden Descargar e Imprimir.",
          expand:false
        },
        {
          title:"Recibí factura y no tengo servicio",
          description:"Tenemos varias opciones para ti. Puedes contactarnos en las redes sociales @claroservicio en Facebook o twitter o en ayuda.claropr.com.",
          expand:false
        },
        {
          title:"¿Puedo realizar pagos desde Mi Claro?",
          description:"Si, a través de nuestra aplicación puedes realizar pagos totales, parciales y/o abonos a tu cuenta. Puedes realizar su pagos con ATH, VISA, MasterCard, American Express, cuenta de cheque o ahorro.",
          expand:false
        },
        {
          title:"¿Es seguro ingresar mis datos de mis tarjetas en este sitio web?",
          description:"Para proteger tus datos (Mi Claro PR) delega en Placetopay de Evertec, Inc la captura de la información sensible. La plataforma de pagos Placetopay cumple con los más altos estándares exigidos por la norma internacional PCI DSS de seguridad en transacciones con tarjeta de crédito, débito y prepago. Además, tiene certificado de seguridad SSL expedido por GeoTrust una compañía Verisign, el cual garantiza comunicaciones seguras mediante la encriptación de todos los datos hacia y desde el sitio; de esta manera, te podrás sentir seguro a la hora de ingresar la información de su tarjeta.",
          expand:false
        },
        {
          title:"¿En qué momento se reflejará el pago en mi cuenta?",
          description:"Si el pago realizado fue con Tarjeta de Crédito o ATH el mismo se reflejará en la próxima hora. Si el pago realizado fue con cuenta de Cheque o Ahorro el mismo se reflejará en 3 días laborables. Si su cuenta es Fija (Residencial) y se encuentra suspendido, puede demorar hasta 8 horas en reestablecer el servicio.",
          expand:false
        },
        {
          title:"¿Tengo teléfono prepagado, puedo registrarme en Mi Claro?",
          description:"Para registrar tu servicio prepagado debes acceder a nuestro Portal Único y seguir las instrucciones en pantalla",
          expand:false
        },
        {
          title:"Se me agoto la data, ¿Qué puedo hacer?",
          description:"En Mi Claro PR app o Web, puedes adquirir paquetes de data adicional y hasta aumentar la data de tu plan actual.",
          expand:false
        },
        {
          title:"¿Cómo puedo conocer las ofertas y productos?",
          description:"Puedes entrar a ",
          link1:"https://tienda.claropr.com ",
          link1text:"https://tienda.claropr.com",
          description2:"y adquirir nuevos equipos y las mejores ofertas en la Red Más Poderosa.",
          expand:false
        },
        {
          title:"¿En cuánto tiempo recibiré mi equipo?",
          description:"Recibirás el equipo dentro de los próximos 3-5 dias laborables sin ningún cargo por envío.",
          expand:false
        }
      ]
    };
    this.loadingScreenService.stopLoading();
  }
  initializeData(){
    this.global.refreshDataTo(this.token);
  }
  updateExpand(index){
    if(this.global.validateSession()===true){
      this.global.validateSession();
      this.expand[index] = !this.expand[index];
    }
  }
}
